// extracted by mini-css-extract-plugin
export default {"CheckIcon":"PlansRadioGroup-module__CheckIcon--Q8ztJ"};